import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import {
  AnalyticsProvider,
  useAnalytics as usePackageAnalytics
} from '@3plearning/mx-teacher-analytics/react';
import buildAnalyticsClient from './create-client';
import buildIdentityProps from './identity';
import { getAnalyticsBuildConfig, getQueryParams } from './config';
import { getLocale } from '../helpers/locale';

export function MxAnalyticsProvider({ children }) {
  const [client] = useState(() =>
    buildAnalyticsClient(getAnalyticsBuildConfig())
  );

  useEffect(() => {
    client.setCommonProps(
      buildIdentityProps(getQueryParams(), getLocale() || 'en-AU')
    );
    client.identify();
  }, [client]);

  return <AnalyticsProvider client={client}>{children}</AnalyticsProvider>;
}

MxAnalyticsProvider.propTypes = {
  children: PropTypes.node
};

// Returns null outside the provider (e.g. isolated unit tests) so call sites
// can no-op instead of throwing.
export function useAnalyticsClient() {
  try {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return usePackageAnalytics();
  } catch (error) {
    return null;
  }
}



// WEBPACK FOOTER //
// ./analytics/mx-analytics-provider.js